import { abUseExperimentsSelector, isAbUseExperimentsActive } from 'shared/selectors';

import type { IState } from 'shared/store';

export const CPD_TRAP_TEXT_CHANGES_EXPERIMENT = 'b2b_cpd_addform_trap_text_changes';

export const selectIsCpdTrapTextExperiment = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, CPD_TRAP_TEXT_CHANGES_EXPERIMENT, 'B');
};
